export default __webpack_public_path__ + "static/bison-skulls-23ccfe1c8889bcc421a865b7d2830cd3.jpg";